<template>
  <v-row class="d-flex align-center justify-space-around" :class="{filteredBorder: filterActive}">
    <v-col sm="3">
      <TotalAccountsInfoCard
        :imgSrc="require(`@/assets/icons/blue-users.png`)"
        title="Total de contas"
        :value="totalAccounts"
      />
    </v-col>
    <v-col sm="3">
      <IndividualAccountsInfoCard
        :imgSrc="require(`@/assets/icons/blue-user.png`)"
        title="Contas Individuais"
        :value="totalIndividualAccounts"
      />
    </v-col>
    <v-col sm="3">
      <CompanyAccountsInfoCard
        :imgSrc="require(`@/assets/icons/blue-users.png`)"
        title="Contas Empresariais"
        :value="totalCompanyAccounts"
      />
    </v-col>
    <v-col sm="3">
      <BlockedAccountsInfoCard
        :imgSrc="require(`@/assets/icons/red-block.png`)"
        title="Contas Bloqueadas"
        :value="totalBlockedAccounts"
      />
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import CompanyAccountsInfoCard from "@/components/molecules/Contas/company-accounts-card";
import IndividualAccountsInfoCard from "@/components/molecules/Contas/individual-accounts-card";
import TotalAccountsInfoCard from "@/components/molecules/Contas/total-accounts-card";
import BlockedAccountsInfoCard from "@/components/molecules/Contas/blocked-accounts-card";

export default {
  components: {
    CompanyAccountsInfoCard,
    IndividualAccountsInfoCard,
    TotalAccountsInfoCard,
    BlockedAccountsInfoCard
  },
  computed: {
    filter() {
      const filterOptions = Object.assign({}, this.$store.getters.filterContas);
      if (filterOptions.startDate) {
        const [year, month, day] = filterOptions.startDate.split("-");
        filterOptions.startDate = `${day}/${month}/${year} 00:00:00`;
        filterOptions.startDate = this.formatDate(filterOptions.startDate);
      }
      if (filterOptions.endDate) {
        const [year, month, day] = filterOptions.endDate.split("-");
        filterOptions.endDate = `${day}/${month}/${year} 23:59:59`;
        filterOptions.endDate = this.formatDate(filterOptions.endDate);
      }
      return filterOptions;
    },
    filteredAccounts() {
      return this.accounts.filter(account => {
        if (!this.filter.country) {
          return account;
        }
        if (this.filter.country && !this.filter.state)
          return account.country === this.filter.country;
        if (this.filter.country && this.filter.state && !this.filter.city)
          return (
            account.country === this.filter.country &&
            account.state === this.filter.state
          );
        if (
          this.filter.country &&
          this.filter.state &&
          this.filter.city &&
          !this.filter.company
        )
          return (
            account.country === this.filter.country &&
            account.state === this.filter.state &&
            account.city === this.filter.city
          );
        if (
          this.filter.country &&
          this.filter.state &&
          this.filter.city &&
          this.filter.company
        )
          return (
            account.country === this.filter.country &&
            account.state === this.filter.state &&
            account.city === this.filter.city &&
            account.company === this.filter.company
          );
      });
    },
    filteredAccountsByDate() {
      return this.filteredAccounts.filter(account => {
        if (this.filter.startDate && !this.filter.endDate)
          return this.formatDate(account.createdAt) > this.filter.startDate;
        if (!this.filter.startDate && this.filter.endDate)
          return this.formatDate(account.createdAt) < this.filter.endDate;
        if (this.filter.startDate && this.filter.endDate) {
          return (
            this.formatDate(account.createdAt) > this.filter.startDate &&
            this.formatDate(account.createdAt) < this.filter.endDate
          );
        }
        return account;
      });
    },
    totalAccounts() {
      return this.filteredAccountsByDate.length;
    },
    totalCompanyAccounts() {
      return this.filteredAccountsByDate.filter(account => account.isCompany)
        .length;
    },
    totalIndividualAccounts() {
      return this.filteredAccountsByDate.filter(
        account => !account.isCompany && !account.companyCnpj
      ).length;
    },
    totalBlockedAccounts() {
      return this.filteredAccountsByDate.filter(account => account.blocked)
        .length;
    }
  },
  methods: {
    formatDate(value) {
      return moment(value, [
        "DD-MM-YYYY HH:mm:ss",
        "YYYY-MM-DDTHH:mm:ss.SSSSZ"
      ]);
    }
  },
  props: {
    accounts: {
      type: Array,
      required: true
    },
    filterActive: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.filteredBorder {
  border: 2px solid #6464ff;
  border-radius: 10px;
}
</style>